<div class="flex flex-row gap-[0.5rem] items-center">
  <div class="text-[0.6875rem] font-[500] leading-[150%] text-(--p-primary-500)" translate="@@shared-sound-signal_label"></div>
  <div class="flex flex-row gap-[0.5rem]">
    <div class="flex flex-row gap-[0.375rem] items-center p-[0.375rem] rounded-[0.25rem] bg-(--p-neutral-500)">
      <div class="text-[0.6875rem] font-[500] leading-[150%] text-(--p-primary-500)">1:</div>
      <gc-ld-logger-noise-sound-signal-load
        styleClass="!gap-[0.25rem]"
        [soundSignalId]="firstLoggerSoundSignalId()"
        [soundSignalUrl]="firstSoundSignalUrl()"
        [hideImg]="!scrRes.isScreenSmUp()"
        [showDownloadAlways]="true">
      </gc-ld-logger-noise-sound-signal-load>
    </div>
    <div class="flex flex-row gap-[0.375rem] items-center p-[0.375rem] rounded-[0.25rem] bg-(--p-neutral-500)">
      <div class="text-[0.6875rem] font-[500] leading-[150%] text-(--p-primary-500)">2:</div>
      <gc-ld-logger-noise-sound-signal-load
        styleClass="!gap-[0.25rem]"
        [soundSignalId]="secondLoggerSoundSignalId()"
        [soundSignalUrl]="secondSoundSignalUrl()"
        [hideImg]="!scrRes.isScreenSmUp()"
        [showDownloadAlways]="true">
      </gc-ld-logger-noise-sound-signal-load>
    </div>
  </div>
</div>
